module.exports = __webpack_public_path__ + "static/img/logo.c338455.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/AbbrHome/logo.png
// module id = 57nu
// module chunks = 2